import { inject, InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';

import { AppComponent } from './components/app/app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { CoreRoutingModule } from './core-routing.module';
import { SharedModule } from '../shared/shared.module';
import { AuthModule as AppAuthModule } from '../auth/auth.module';
import { tokenInterceptor } from '../auth/interceptors/token.interceptor';
import { environment } from '../../../environments/environment';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './core.routes';
import { loaderInterceptor } from '../shared/interceptors/loader.interceptor';
import { UserModule } from '../user/user.module';
import { LangInterceptor } from '../shared/interceptors/lang.interceptor';



export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const ENTRA_ID_REDIRECT_URL = new InjectionToken<string>(
  'ENTRA_ID_REDIRECT_URL'
);
registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
  ],
  imports: [
    // Angular packages
    BrowserModule,
    BrowserAnimationsModule,
    CoreRoutingModule,

    // Plugins packages
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),

    // App packages

    SharedModule,
    AppAuthModule,
    UserModule,
  ],
  providers: [
    provideHttpClient(
      withInterceptors([tokenInterceptor]),
      withInterceptorsFromDi()
    ),
    provideAnimationsAsync(),
    { provide: HTTP_INTERCEPTORS, useClass: loaderInterceptor, multi: true },
    { provide: 'OAUTH2_PROVIDERS_URL', useValue: environment.api.providers },
    { provide: 'API_BASE_URL', useValue: environment.api.host },
    { provide: 'LOADER_ON_HTTP', useValue: environment.loaderOnHttp },
    provideRouter(routes, withComponentInputBinding()),
    { provide: HTTP_INTERCEPTORS, useClass: LangInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class CoreModule {
  translate = inject(TranslateService);
  public constructor() {
    let lang = localStorage.getItem('lang') || this.translate.getBrowserLang() || 'fr';
    lang = ['fr', 'en'].includes(lang) ? lang : 'fr';
    this.translate.use(lang);
    this.translate.setDefaultLang(lang);
  }
}

// Lokalise translations
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.api.host + '/lokalise/', '.json');
}

// Local translations
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
